import { useHeightSyncState } from '../hooks/useHeightSyncState'

import { NewOptInInfoCard } from './components/NewOptInInfoCard'
import classes from './styles.module.scss'

type BuilderProps = {
  data: {
    items: {
      title: string
      text: string
    }[]
  }
}

export const NewOptInInfoCards = ({ data }: BuilderProps) => {
  const { registerHeight, maxHeight } = useHeightSyncState()

  return (
    <div className={classes.root}>
      {data.items.map((item, index) => (
        <NewOptInInfoCard
          key={`${item.title}-${index}`}
          title={item.title}
          text={item.text}
          step={(index + 1).toString()}
          registerHeight={registerHeight}
          maxHeight={maxHeight}
        />
      ))}
    </div>
  )
}
